import type { CategoryType, ServiceType } from '../../types'
import type { ISkils } from '../../types/other.types'
import { baseApi } from '../baseApi'
import type { ITenantUser, ITenantUsersResponse, ResponseType } from '../types'

export const webPageApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllSkils: builder.query<ResponseType<ISkils[]>, string>({
            query: (qwery) => `/api/technicians/skills?${qwery}`,
        }),
        getAllCertificates: builder.query<ResponseType<ISkils[]>, string>({
            query: (qwery) => `/api/technicians/certificates?${qwery}`,
        }),
    }),
})

export const {
    useGetAllSkilsQuery,
    useLazyGetAllSkilsQuery,
    useGetAllCertificatesQuery,
    useLazyGetAllCertificatesQuery,
} = webPageApi
